// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3YReZ","faceup":"Card_faceup__3IWZH","textCenter":"Card_textCenter__1Wo6n"};